export default (dateString) => {
  const date = new Date(dateString)
  if (date) {
    return ('0' + (date.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + date.getUTCDate()).slice(-2) + '-' + date.getUTCFullYear()
  }
  return dateString
}